<template>
  <div class="player-detail">
    <v-loading-spinner v-if="loading"/>
    <template v-if="!loading">
      <v-player-header :player="player" />

      <v-player-stat-chooser :player="player" @input="statPath = $event" />

      <v-player-pro-career-overview :player="player" v-if="false" />

      <v-player-data-table-by-year v-if="!pathHasCollege" :player="player" :path="prodEnumPath" />

      <v-player-data-table-by-enum v-if="pathHasCollege" :player="player" :path="prodEnumPath" />

      <v-player-external-links :player="player" />
    </template>
  </div>
</template>

<script>
import PlayerApi from '~/api/Player';

export default {
  name: 'Player',

  props: {
    playerProp: { type: Object, default: () => {} },
  },

  computed: {
    playerId() { return this.$route.params.playerId; },

    pathArray() { return this.statPath.split('.children.'); },

    prodEnumPath() { return this.pathArray.join('.').replace('pro.', ''); },

    pathHasCollege() { return this.pathArray.indexOf('college') > -1; },

    pathHasPro() { return this.pathArray.indexOf('pro') > -1; },

    pathHasCollegePhysical() { return this.path === 'college.children.physical'; },

    pathHasCollegeDash() { return this.path === 'college.children.dash'; },

    pathHasCollegeJump() { return this.path === 'college.children.jump'; },

    pathHasCollegeAgility() { return this.path === 'college.children.agility'; },

    pathHasCollegeBench() { return this.path === 'college.children.bench'; },
  },

  data() {
    return {
      player: _.get(this.$route, 'params.playerProp', {}),
      loading: false,
      statPath: '',
    };
  },

  watch: {
    async playerId() {
      await this.updatePlayer();
      await this.updateCareerBoxScores();
    },
  },

  methods: {
    async updatePlayer() {
      const pid = _.get(this.player, 'playerId', false);
      if (!pid || pid !== this.playerId) {
        this.loading = true;
        this.player = {};
        const response = await PlayerApi.get(this.playerId);
        this.player = response.data;
        this.loading = false;
      }
    },
    async updateCareerBoxScores() {
      if (!_.get(this.player, 'boxScores', false)) {
        this.loading = true;
        const res = await PlayerApi.getCareerBoxScores(this.player.playerId);
        const boxScore = _.chain(res.data).sortBy('year').reverse().head()
          .value();
        this.player = { ...this.player, boxScore, boxScores: res.data };
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.updatePlayer();
    await this.updateCareerBoxScores();
  },
};
</script>

<style lang="scss">
  @import '@/assets/scss/_component_helpers.scss';

  .player-detail {

  }
</style>
